export default __webpack_public_path__ + "static/media/s1-video.eb5a1522.mp4";